<iframe id="triggerSaveCredentialsFix" name="triggerSaveCredentialsFix" hidden="hidden"></iframe>
<div class="gp-pagewidth gp-pagewidth-login-form">
    @if (!isAuthenticated()) {
        <form class="form" id="login-form" target="triggerSaveCredentialsFix" action="/login" method="post" (ngSubmit)="login()">
            <div class="gp-component-login-container">
                <div class="row">
                    <label class="col-md-12 fw-semibold">
                        <div class="col-form-label">{{ "LOGINPANEL.USERNAME" | translate }}</div>
                        <input
                            class="form-control"
                            placeholder="{{ 'LOGINPANEL.USERNAME' | translate }}"
                            name="username"
                            [(ngModel)]="username"
                            [required]="true"
                            autofocus="autofocus"
                        />
                    </label>
                </div>
                <div class="row">
                    <label class="col-md-12 fw-semibold">
                        <div class="col-form-label">{{ "LOGINPANEL.PASSWORD" | translate }}</div>
                        <input
                            class="form-control"
                            placeholder="{{ 'LOGINPANEL.PASSWORD' | translate }}"
                            name="password"
                            type="password"
                            [(ngModel)]="password"
                            [required]="true"
                        />
                    </label>
                </div>
                <div class="row form-submit d-flex mt-3">
                    <label class="col-md-6">
                        <input type="checkbox" [(ngModel)]="rememberme" name="rememberme" class="me-1" />
                        <span>{{ "LOGINPANEL.STAY_SIGNED_IN" | translate }}</span>
                    </label>
                    <label class="col-md-6 text-end">
                        <button class="btn btn-secondary">
                            {{ "LOGINPANEL.LOGIN" | translate }}
                        </button>
                    </label>
                </div>
                <div class="mt-3 text-end">
                    <a [uiParams]="{ userName: username }" uiSref="home.passwordrecovery">{{ "ACCOUNT.FORGET_PASSWORD" | translate }}</a>
                </div>
                <div class="mt-3 text-end">
                    <a uiSref="home.modeldownload">Modell-Dateien herunterladen</a>
                </div>
            </div>
        </form>
    }
</div>
